module.exports = __webpack_public_path__ + "img/about.94058744.jpg";